// Core Modules
import { Component, HostListener, inject } from '@angular/core';

// Tokens
import { WINDOW } from '@core/injection-tokens/tokens';

@Component({
  selector: 'app-back-to-top',
  standalone: true,
  imports: [],
  templateUrl: './back-to-top.component.html',
  styleUrl: './back-to-top.component.scss',
})
export class BackToTopComponent {
  // Injectors
  private readonly window = inject(WINDOW);

  // Private Members
  private readonly topPosToStartShowing: number = 500;

  // Public Members
  public showBackToTop: boolean = false;

  @HostListener('window:scroll')
  public checkScroll(): void {
    // window scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

    const scrollPosition = this.window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.showBackToTop = scrollPosition >= this.topPosToStartShowing;
  }

  public scrollToTop(): void {
    this.window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
